import {h, Component} from 'preact'
import { connectHits } from 'react-instantsearch-dom'
import {Hit} from '../algolia/components/index'

interface Props {
  hits: Hit[],
  topicId: string,
  widgetTitle: string,
  totalItemCount: number
}

export class RelatedTopicsList extends Component<Props> {
  render (params: Props) {
    const { hits, topicId, widgetTitle, totalItemCount } = params
    const hitsWithoutCurrent = hits.filter((hit) => hit.id !== parseInt(topicId)).slice(0, totalItemCount)

    if (!hitsWithoutCurrent.length) return null

    return (
      <div className='box__content widget box__pad widget--related-topics'>
        { widgetTitle ? <h3 className='widget-title related-topics__widget-title'>{widgetTitle}</h3> : '' }
        <ul class='simple-topic-list'>
          {
            hitsWithoutCurrent.map((hit) => {
              let iconClass = hit.has_answer ? 'icon--checkmark qa-icon-answered' : hit.content_type === 'question' ? 'icon--question qa-icon-question' : ''

              return <li className='related-topics__topic simple-topic-list--item'>
                <h6 className='related-topics__topic-title simple-topic-list--title'>
                  <a className='link link--topic' href={hit.topic_url}>{hit.title}</a>
                  {iconClass ? <span class={'icon icon--replace icon--round ' + iconClass}>icon</span> : ''}
                </h6>
                <a href={`/fid-${hit.forum}`} class='text--meta'>{ hit.forum_title }</a>
              </li>
            })
          }
        </ul>
      </div>
    )
  }
}

const RelatedTopicsListContainer = connectHits(RelatedTopicsList)

export default RelatedTopicsListContainer
